export const defaultPaperAllSelector = (state) =>
  state?.defaultPaperReducer?.defaultPaperAll;
export const defaultPaperOpenAddSelector = (state) =>
  state?.defaultPaperReducer?.defaultPaperOpenAdd;
export const defaultPaperOpenEditSelector = (state) =>
  state?.defaultPaperReducer?.defaultPaperOpenEdit;
export const defaultPaperSelectedSelector = (state) =>
  state?.defaultPaperReducer?.defaultPaperSelected;
export const defaultPaperSearchSelector = (state) =>
  state?.defaultPaperReducer?.defaultPaperSearch;
